import React from "react";

import cronstrue from "cronstrue";

import * as Code from "ds/Code";

import * as S from "./Crons.styles";

export interface CronProps {
  commands: {
    start: string;
    stop: string;
  };
  name: string;
  spec: string;
}

const Cron = ({ commands, name, spec }: CronProps) => {
  const humanSpec = cronstrue.toString(spec);

  return (
    <>
      <S.Cell>
        <S.Title>{name}</S.Title>
      </S.Cell>
      <S.Cell>{humanSpec}</S.Cell>
      <Code.Block isCopyable singleLine id={commands.start}>
        {commands.start}
      </Code.Block>
    </>
  );
};

export default Cron;
